import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';
import { NumberPad, numberPadTypes } from './NumberPad';

const withDecimal = true

const NumberPadPicker = (props) => {

  const { fip } = props ?? {}
  const { propname, onChange } = fip ?? {}

  const [_fip, set_fip] = useState(fip)

  const handleChange = (e, data) => {
    const _fipp = { ..._fip }
    const { value } = data
    const _data = { propname, value: value ? value : 0 }
    _fipp.value = value
    onChange(null, _data)
    set_fip(_fipp)
  }

  return <React.Fragment>
    <div className='field'>
      <label style={{ float: 'left' }}>{_fip.label}</label>
    </div>
    <NumberPad
      value={_fip.value}
      onChange={handleChange}
      opts={{ noSize: true, propKey: 'giftCardAmount', forEdit: true }}
      icon={<Icon name='dollar' />}
      withDecimal={withDecimal}
      numberPadType={numberPadTypes.grid}
    />
  </React.Fragment>
}

export default NumberPadPicker